import { fileUpload, electricSign, recallApElectronic, exportTemplate } from '../../../api/statement/statementApi';
import { DEALINGSACCOUNT } from '../../../utils/configuration';
export default {
    data() {
        return {};
    },
    computed: {
        isSaveFlag() { // 对账单状态“已发函、已回复差异”时可操作
            if (+this.balanceDetail.dealingsBillStatus === DEALINGSACCOUNT.SENT_LETTER || +this.balanceDetail.dealingsBillStatus === DEALINGSACCOUNT.DIFFERENCE_RECOVERED) {
                return false;
            } else {
                return true;
            }
        },
        isConfirmFlag() { // 对账模式为“线上对账”且对账单状态为“已发函、已回复差异”时可编辑
            if (this.balanceDetail.accountMode === 'A' && (+this.balanceDetail.dealingsBillStatus === DEALINGSACCOUNT.SENT_LETTER ||
                 +this.balanceDetail.dealingsBillStatus === DEALINGSACCOUNT.DIFFERENCE_RECOVERED)) {
                return false;
            } else {
                return true;
            }
        },
        isFildUplodFlag() { // 对账单状态为“已发函、供方确认差异、已回复差异”时可操作
            if (+this.balanceDetail.dealingsBillStatus === DEALINGSACCOUNT.SENT_LETTER || +this.balanceDetail.dealingsBillStatus === DEALINGSACCOUNT.SUPPLIER_CONFIRM_DIFF ||
                 +this.balanceDetail.dealingsBillStatus === DEALINGSACCOUNT.DIFFERENCE_RECOVERED) {
                return false;
            } else {
                return true;
            }
        },
        isSealFlag() { // 对账单状态为“供方确认差异、供方确认一致”时可操作
            if (+this.balanceDetail.dealingsBillStatus === DEALINGSACCOUNT.SUPPLIER_CONFIRM_AGREE || +this.balanceDetail.dealingsBillStatus === DEALINGSACCOUNT.SUPPLIER_CONFIRM_DIFF) {
                return false;
            } else {
                return true;
            }
        },
        isCancelFlag() { // 对账模式为"线上对账"且对账单状态为"供方确认一致"可以操作，其他状态下置灰和不能点击
            if (this.balanceDetail.accountMode === 'A' && +this.balanceDetail.dealingsBillStatus === DEALINGSACCOUNT.SUPPLIER_CONFIRM_AGREE) {
                return false;
            } else {
                return true;
            }
        }
    },
    methods: {
        fileUpload() {
            this.$refs.filesUpload.dialogVisible = true;
        },
        // 附件上传
        simpleUpload(uploadData) {
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('jobId', this.balanceDetail.jobId);
            formData.append('dealingsBillNo', this.balanceDetail.dealingsBillNo);
            this.$refs.filesUpload.isDialogLoading = true;
            fileUpload(formData).then(res => {
                if (res && +res.code === 0) {
                    this.$refs.filesUpload.dialogVisible = false;
                    this.getBalanceDetails();
                    this.$message.success('调整项明细附件上传成功');
                }
            }).finally(() => { this.$refs.filesUpload.isDialogLoading = false; });
        },
        // 电子签章
        electronicSeal() {
            if (this.$refs.balanceSurey.leftBalance !== this.$refs.balanceSurey.rightBalance) {
                return this.$message.warning('供方确认差异不允许盖章，已通知安得财务处理');
            }
            this.loading = true;
            const params = {
                jobId: this.balanceDetail.jobId,
                supCode: this.balanceDetail.supCode,
                ledgerId: this.balanceDetail.ledgerId,
                dealingsBillNo: this.balanceDetail.dealingsBillNo
            };
            electricSign(params).then(res => {
                if (res && +res.code === 0) {
                    this.getBalanceDetails();
                    this.$message.success('电子签章成功');
                }
            }).finally(() => { this.loading = false; });
        },
        // 电子签章撤回
        electronicSealRecall() {
            this.loading = true;
            const params = {
                jobId: this.balanceDetail.jobId,
                dealingsBillNo: this.balanceDetail.dealingsBillNo
            };
            recallApElectronic(params).then(res => {
                if (res && +res.code === 0) {
                    this.getBalanceDetails();
                    this.$message.success('电子签章撤回成功');
                }
            }).finally(() => { this.loading = false; });
        },
        // 附件模板下载
        templateDownload() {
            exportTemplate().then(res => {
                if (res) {
                    const blod = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const url = window.URL.createObjectURL(blod);
                    const a = document.createElement('a');
                    document.body.appendChild(a);
                    const fileName = 'EfApDealingsBillTem';
                    a.href = url;
                    a.download = fileName; // 命名下载名称
                    a.click(); // 点击触发下载
                    window.URL.revokeObjectURL(url); // 下载完成进行释放
                }
            });
        },
        // 下载查看上传的附件
        viewAttachment() {
            if (this.balanceDetail.fileDownUrl) window.open(`${this.balanceDetail.fileDownUrl}`);
            else this.$message.warning('该对账单无附件信息');
        }
    }
};
